// ─── «Lo que falta cargar» en el resumen del curso (puro, con test) ─────────
// `tasksRead = false` es «no se pudo leer», no «no hay»: un cero por una
// lectura fallida y un cero real se verían idénticos.
//
// Con `graduation_audit` el seminario lleva su expediente en su sistema de
// origen y no publica tareas aquí: «ninguna tarea publicada» no es una alarma,
// es su forma de trabajar. Se calla SOLO ese aviso; los demás siguen igual.

export interface LoadAlerts {
  noAssignments: boolean;
  unpublished: number;
  modulesWithoutSessions: number;
  show: boolean;
  severity: 'error' | 'warning';
}

export function loadAlerts(input: {
  tasksRead: boolean;
  published: number;
  unpublished: number;
  modulesWithoutSessions: number;
  importedRecord: boolean;
}): LoadAlerts {
  const noAssignments = input.tasksRead && input.published === 0 && !input.importedRecord;
  return {
    noAssignments,
    unpublished: input.unpublished,
    modulesWithoutSessions: input.modulesWithoutSessions,
    show: noAssignments || input.unpublished > 0 || input.modulesWithoutSessions > 0,
    severity: noAssignments ? 'error' : 'warning',
  };
}
